import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { Modal, ConfigProvider } from "antd";
import {
  updateShowRoomNumberModal,
  saveTempSelectedRoomWTypeAndNum,
  updateTempSelectedRoomWTypeAndNum,
  updateAdults,
  updateRoomChangeMade,
} from "../../../reducer/bookingReducer";
import { CloseOutlined } from "@ant-design/icons";
import useAllBookingFunction from "../../../hooks/bookingCustomHook/useAllBookingFunction";

const Room = () => {
  const dispatch = useDispatch();

  const {
    roomAvailabiltyArray,
    tempSelectedRoomWTypeAndNum,
    selectedRoomWTypeAndNum,
    showRoomNumberModal,
    roomPriceStructure,
    mealPlan,
  } = useSelector((store) => store.booking);

  const { occupancyPlanRate } = useSelector((store) => store.login);

  const {
    handleRoomSelectionModalApplyButtonUpdateBooking,
    handleSelectedRoomChangeInRoomSelectionModal,
  } = useAllBookingFunction();

  const handleCancel = () => {
    dispatch(updateTempSelectedRoomWTypeAndNum(selectedRoomWTypeAndNum));
    dispatch(updateShowRoomNumberModal());
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          margin: 0,
          padding: 2,
        },
      }}
    >
      <Modal
        title={
          <div className="w-[100%] flex justify-between items-center mr-3">
            <div className="font-body font-[600] ">Select Room</div>{" "}
            <div className="flex gap-2 items-center">
              <div className="w-[full]  bottom-[25%] left-[40%] bg-surface flex justify-center">
                <button
                  className="border-accent border-[1px] text-accent   text-[1.125rem] font-[400] 
                  leading-[1.6875rem]  font-body  rounded-[0.625rem] cursor-pointer flex justify-center items-center p-2 px-3"
                  onClick={() =>
                    handleRoomSelectionModalApplyButtonUpdateBooking()
                  }
                >
                  Apply Changes
                </button>
              </div>
              <CloseOutlined
                onClick={handleCancel}
                className=" customCloseIconContainer"
              />
            </div>
          </div>
        }
        closeIcon={null}
        open={showRoomNumberModal}
        onCancel={handleCancel}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        footer={null}
        width={"45rem"}
        style={{ height: "65vh", overflowY: "auto" }}
      >
        <div className=" overflow-y-auto">
          <div className="flex flex-col gap-3  items-start justify-center  text-center">
            {roomAvailabiltyArray?.map((val, index) => {
              return (
                <div key={index} className="">
                  <div className="flex gap-2 items-center">
                    <h1 className="relative font-[500] font-body text-[1rem] text-fg-secondary">
                      {val.name}{" "}
                    </h1>
                    <p className="font-[300] text-[0.75rem] font-body text-fg-secondary">
                      Select any {val.availability} room
                    </p>
                  </div>

                  <div
                    className="flex flex-wrap"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {val.rooms?.map((item, index) => {
                      return tempSelectedRoomWTypeAndNum[val.name]
                        ?.map((pd) => pd.name)
                        ?.indexOf(item.name) > -1 ? (
                        <div
                          onClick={() =>
                            handleSelectedRoomChangeInRoomSelectionModal(
                              true,
                              val.name,
                              item.name,
                              item,
                              tempSelectedRoomWTypeAndNum,
                              updateTempSelectedRoomWTypeAndNum,
                              roomPriceStructure
                            )
                          }
                          key={index}
                          className=""
                        >
                          <div className="border-[1px] text-fg-inverse py-[3px] px-2 rounded-lg bg-primary m-2 cursor-pointer">
                            {item.name}
                          </div>
                        </div>
                      ) : (
                        <div
                          onClick={() =>
                            handleSelectedRoomChangeInRoomSelectionModal(
                              false,
                              val.name,
                              item.name,
                              item,
                              tempSelectedRoomWTypeAndNum,
                              updateTempSelectedRoomWTypeAndNum,
                              roomPriceStructure
                            )
                          }
                          key={index}
                          className=""
                        >
                          <div className="border-[1px] bg-neutral-50 py-[3px] px-2 rounded-lg text-[gray] m-2 cursor-pointer ">
                            {item.name}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default Room;
